var map = {
	"./pros-0.png": "TjCj",
	"./pros-1.png": "FmZB",
	"./pros-2.png": "adkg",
	"./pros-3.png": "UP8I"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yYFX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home ^\.\/pros\-.*\.png$
// module id = yYFX
// module chunks = 1